import React from 'react'
import styled from 'styled-components'
import { Link } from 'rebass'

import mcdLogo from '../images/mcd-logo.svg'
import mcdLogoZebra from '../images/mcd-logo-zebra.svg'
import media from './Media'

const Logo = styled.div`
  background-image: url(${mcdLogo});
  background-size: cover;
  height: 64px;
  width: 64px;
  margin: 0 auto;
  position: relative;
  z-index: 10;

  ${media.desktop`
    background-image: url(${mcdLogoZebra});
  `}
`

const Nav = styled.nav`
  background: ${props => props.theme.colors.black};
  padding: ${props => props.theme.space[3]}px 0;
  width: 100%;

  ${media.desktop`
    background: transparent;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  `}
`

const Header = () => (
  <Nav>
    <Link href="https://mcdbooks.com">
      <Logo />
    </Link>
  </Nav>
)

export default Header
